<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">
			{{ surveyResponse.survey.name }}
		</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="back()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'backward']" size="lg" class="ms-1 me-2"></fa-icon>
						Back
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="p-grid">
				<div class="p-col-12 display-12">{{ surveyResponse.contactInformation.firstName }} {{ surveyResponse.contactInformation.lastName }}</div>
			</div>
			<div class="p-grid" *ngIf="surveyResponse.contactInformation?.email || surveyResponse.contactInformation?.phone">
				<div class="p-col-6 display-12">
					<span *ngIf="surveyResponse.contactInformation?.email">
						<a href="mailto:{{ surveyResponse.contactInformation.email }}">{{ surveyResponse.contactInformation.email }}</a>
					</span>
				</div>
				<div class="p-col-6 display-12 text-right">
					{{ surveyResponse.contactInformation.phone }}
				</div>
			</div>
			<div class="display-12">Responded {{ app.moment(surveyResponse.responseDate).format("L LT") }}</div>
			<ng-container *ngFor="let question of surveyResponse.questions; let index = index">
				<div class="mt-4">
					<ng-container *ngIf="question.answer.type === 1">
						<div class="display-14 mb-2">{{ question.question }}</div>
						<input
							pInputText
							#question{{index}}value
							name="question{{ index }}value"
							type="text"
							[(ngModel)]="question.answer.value"
							class="w-100"
							[disabled]="true"
						/>
					</ng-container>
					<ng-container *ngIf="question.answer.type === 2">
						<div class="display-14 mb-2">{{ question.question }}</div>
						<textarea
							[disabled]="true"
							pInputTextarea
							#question{{index}}value
							name="question{{ index }}value"
							[(ngModel)]="question.answer.value"
							class="w-100 mt-1"
							rows="3"
						></textarea>
					</ng-container>
					<ng-container *ngIf="question.answer.type === 3">
						<div class="display-14 mb-2">{{ question.question }}</div>
						<div class="my-auto">
							<p-slider
								[disabled]="true"
								[(ngModel)]="question.answer.value"
								[min]="question.answer.scale.min"
								[max]="question.answer.scale.max"
								[step]="question.answer.scale.step"
								[animate]="true"
								styleClass="mt-2 my-auto"
							></p-slider>
							<div class="display-14 text-center">{{ question.answer.value }}</div>
						</div>
					</ng-container>
					<ng-container *ngIf="question.answer.type === 4">
						<div class="display-14 mb-2">{{ question.question }}</div>
						<div class="w-100 text-right">
							<p-selectButton
								[disabled]="true"
								[options]="[question.answer.boolean.true, question.answer.boolean.false]"
								[(ngModel)]="question.answer.value"
								styleClass="w-100 mt-2"
							></p-selectButton>
						</div>
					</ng-container>
					<ng-container *ngIf="question.answer.type === 5">
						<div class="display-14 mb-2">{{ question.question }}</div>
						<p-listbox
							[disabled]="true"
							[options]="question.answer.choice.choices"
							[(ngModel)]="question.answer.value"
							[multiple]="question.answer.choice.multiple"
							styleClass="w-100 mt-2"
						></p-listbox>
					</ng-container>
				</div>
			</ng-container>
		</div>
		<div class="p-col-12 p-md-6">
			<app-check-record-viewer [checkKey]="surveyResponse.checkKey" [venueKey]="surveyResponse.venueKey"></app-check-record-viewer>
		</div>
	</div>
</div>
